var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.75L9.25 7.5M9.25 7.5L7 5.25M9.25 7.5H1M4.75 3.93644V3.90015C4.75 3.06007 4.75 2.63972 4.91349 2.31885C5.0573 2.0366 5.2866 1.8073 5.56885 1.66349C5.88972 1.5 6.31007 1.5 7.15015 1.5H10.6001C11.4402 1.5 11.8597 1.5 12.1805 1.66349C12.4628 1.8073 12.6929 2.0366 12.8367 2.31885C13 2.6394 13 3.05925 13 3.89768V11.1027C13 11.9411 13 12.3604 12.8367 12.6809C12.6929 12.9632 12.4628 13.1929 12.1805 13.3367C11.86 13.5 11.4408 13.5 10.6023 13.5H7.14768C6.30925 13.5 5.8894 13.5 5.56885 13.3367C5.2866 13.1929 5.0573 12.9629 4.91349 12.6807C4.75 12.3598 4.75 11.9401 4.75 11.1V11.0625",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a631adbff0a63d86b762f684e552cf9e.svg";
export { ForwardRef as ReactComponent };